import React, {FunctionComponent, ReactNode} from 'react'
import styles from './NotFound.module.sass'
import NotFoundImage1 from '../../../../files/notfound/empty_1.svg'
import NotFoundImage2 from '../../../../files/notfound/empty_2.svg'
import NotFoundImage3 from '../../../../files/notfound/empty_3.svg'
import NotFoundImage4 from '../../../../files/notfound/empty_4.svg'

interface Props {
    className?: string,
    headerText: string,
    infoText?: string,
    actions?: ReactNode,
    imageName: 'EMPTY_1' | 'EMPTY_2' | 'EMPTY_3' | 'EMPTY_4'
}

const NotFound: FunctionComponent<Props> = props => {
    return <div className={styles.notFound}>
        <div className={styles.imgBlock}>
            {
                (() => {
                    switch (props.imageName) {
                        case "EMPTY_1": // eslint-disable-line
                            return <NotFoundImage1/>
                        case "EMPTY_2": // eslint-disable-line
                            return <NotFoundImage2/>
                        case "EMPTY_3": // eslint-disable-line
                            return <NotFoundImage3/>
                        case "EMPTY_4": // eslint-disable-line
                            return <NotFoundImage4/>
                        default:
                            return ''
                    }
                })()
            }
        </div>
        <div className={styles.header}>{props.headerText}</div>
        <div className={styles.infoBlock}>{props.infoText}</div>
        {props.actions}
    </div>
}

export default NotFound